export default __webpack_public_path__ + "static/media/state-of-the-climate.f1985602.svg";